import { createBrowserRouter, Navigate } from 'react-router-dom'

import AuthenticatedLayout from '@/layouts/authenticated-layout'
import { ROUTES } from '@/config/routes'

import Protected from './protected'
import AdminRoute from './admin'
// import SigninProtected from './signinProtect'
import PermissionRoute from './permission'
// import FirstAcess from './firstAcess'

import SignIn from '@/pages/SignIn'
import ForgotPassword from '@/pages/password-recovery'

import { TermsOfUse } from '@/components/form/termos'
import MinutaUser from '@/components/form/agreement/minuta-user'
import UpdateCepUsuario from '@/pages/cep-usuario'
import MinutaRead from '@/components/form/agreement/minuta-read'
import AssinarClient from '@/features/signatures/components/assinar-client'
import { LoginFormClient, LoginFormClientMinuta } from '@/features/auth/components'

import KlingerMobilePage from '@/LandingPage/klingerLangingPage'
import MDMobilePage from '@/LandingPage/mdLangingPage'

import BahiaSulPage from '@/LandingPage/bahiaLandingPage'
import TrisolutionPage from '@/LandingPage/trisolutionLangingPage'
import LandingPage from '@/pages/leadingpage'
import WebRoute from './webAcess'
import AcessRoute from './Acess'
import DSPage from '@/LandingPage/dsLangingPage'
// import CepRoute from './cepRoute'
import MinutaUserRoute from './minutaUserRoute'
import { AlertsPage } from '@/pages/alerts-page'
import { ClientesListPage } from '@/pages/clientes-list'
import { GerarMinutaPage } from '@/pages/gerar-minuta'
import { CadastrarClientePage } from '@/pages/cadastrar-cliente'
import { CadastrarClientePageCnpj } from '@/pages/cadastrar-cliente-cnpj'
import { ListarParceirosPage } from '@/pages/parceiros/parceiros-list'
import { CadastrarParceiroPage } from '@/pages/parceiros/parceiros-cadastrar'
import { CadastrarContabilidadePage } from '@/pages/parceiros/parceiros-cadastrar-contabilidade'
import UsersPage from '@/pages/admin/users'
import ContratoForm from '@/components/form/contrato/contrato-form'
import BankRegistration from '@/components/form/banco/bank-form'
import ResumoBoleto from '@/components/form/home/resumo-boleto'
import FinanceiraResumo from '@/components/form/home/resumo-financeiras'
import ErrorPage from '@/pages/error'
import SignaturesPage from '@/pages/admin/signatures'
import ClientesPage from '@/pages/clients-page'
import ClientsInfo from '@/pages/clients/clients-info'
import ClientsAddProduct from '@/pages/clients/clients-add-product'
import ClientsProducts from '@/pages/clients/clients-products'
// import { CadastrarClientePageCpf } from '@/pages/cadastrar-cliente-cpf'
import { CadastrarClientePagePf } from '@/pages/cadastrar-cliente-pf'

// import MinutaPage from '../features/agreement/components/minuta/index'
import UserDetailsPage from '@/pages/admin/user-details'
import { PermissionsManagerWrapper, UserEditWrapper } from '@/pages/admin/wrappers'
import ProductManagement from '@/features/products/components/ProductManager'
import EditPreview from '@/features/agreement/components/minutaPreview'
import ListarAgreements from '@/features/agreement/components/lista-minuta-clients'
import MinutaPage from '../features/agreement/components/minuta/index'
import AssinarWitness from '@/features/signatures/components/assinar-witness'
import { AuthGate } from './AuthGate'
import ClientPortalRoute from './clientPortalRoute'
import ClientHomePage from '@/pages/client-home'
import ConfirmOwnerEmailPage from '@/pages/confirm-owner-email'

const RouterList = createBrowserRouter([
  {
    path: '/confirmar-email-proprietario',
    element: (
      <WebRoute>
        <ConfirmOwnerEmailPage />
      </WebRoute>
    ),
    errorElement: <ErrorPage />
  },
  {
    path: ROUTES.FORGOT_PASSWORD.path,
    element: (
      <WebRoute>
        <ForgotPassword />
      </WebRoute>
    ),
    errorElement: <ErrorPage />
  },
  // { path: ROUTES.SIMPLES.path, element: <SimplesNacional /> },
  { path: ROUTES.MD_MOBILE.path, element: <MDMobilePage />, errorElement: <ErrorPage /> },
  { path: ROUTES.KLINGER_MOBILE.path, element: <KlingerMobilePage />, errorElement: <ErrorPage /> },
  { path: ROUTES.BAHIA_SUL.path, element: <BahiaSulPage />, errorElement: <ErrorPage /> },
  { path: ROUTES.TRISOLUTION.path, element: <TrisolutionPage />, errorElement: <ErrorPage /> },
  { path: ROUTES.DS_PAGE.path, element: <DSPage />, errorElement: <ErrorPage /> },
  {
    path: '/minuta/:id',
    element: (
      <WebRoute>
        <MinutaPage />
      </WebRoute>
    ),
    errorElement: <ErrorPage />
  },
  {
    path: '/assinar-testemunha/:id_client/:slot',
    element: (
      <WebRoute>
        <AssinarWitness />
      </WebRoute>
    ),
    errorElement: <ErrorPage />
  },

  {
    path: '/minuta-read/:idtenant/:contratos',
    element: (
      <WebRoute>
        <MinutaRead />
      </WebRoute>
    ),
    errorElement: <ErrorPage />
  },
  {
    path: ROUTES.LOGIN_CLIENT_MINUTA.path,
    element: (
      <WebRoute>
        <LoginFormClientMinuta />
      </WebRoute>
    ),
    errorElement: <ErrorPage />
  },
  {
    path: ROUTES.LOGIN_CLIENT.path,
    element: (
      <WebRoute>
        <LoginFormClient />
      </WebRoute>
    ),
    errorElement: <ErrorPage />
  },
  {
    path: ROUTES.CLIENT_HOME.path,
    element: (
      <WebRoute>
        <ClientPortalRoute>
          <ClientHomePage />
        </ClientPortalRoute>
      </WebRoute>
    ),
    errorElement: <ErrorPage />
  },
  {
    path: '/client-home/minuta/:id',
    element: (
      <WebRoute>
        <ClientPortalRoute>
          <MinutaPage />
        </ClientPortalRoute>
      </WebRoute>
    ),
    errorElement: <ErrorPage />
  },

  {
    path: '/assinar-contrato/:id_client',
    element: (
      <WebRoute>
        <ClientPortalRoute>
          <AssinarClient />
        </ClientPortalRoute>
      </WebRoute>
    ),
    errorElement: <ErrorPage />
  },
  {
    path: ROUTES.SIGNIN.path,
    element: (
      <WebRoute>
        {/* <SigninProtected> */}
        <SignIn />
        {/* </SigninProtected> */}
      </WebRoute>
    ),
    errorElement: <ErrorPage />
  },
  {
    path: ROUTES.CEP.path,
    element: (
      <WebRoute>
        {/* <CepRoute> */}
        <UpdateCepUsuario />
        {/* </CepRoute> */}
      </WebRoute>
    ),
    errorElement: <ErrorPage />
  },
  {
    path: ROUTES.TERMS_OF_USE.path,
    element: (
      <WebRoute>
        {/* <FirstAcess> */}
        <TermsOfUse />
        {/* </FirstAcess> */}
      </WebRoute>
    ),
    errorElement: <ErrorPage />
  },
  {
    path: ROUTES.HOME.path,
    element: (
      <AcessRoute>
        <LandingPage />
      </AcessRoute>
    ),
    errorElement: <ErrorPage />
  },
  {
    path: '/',
    element: <AuthGate />,
    children: [
      {
        path: '/minuta-usuario/:id',
        element: (
          <WebRoute>
            <Protected>
              <MinutaUser />
            </Protected>
          </WebRoute>
        ),
        errorElement: <ErrorPage />
      },
      {
        path: ROUTES.MINUTE_USER.path,
        element: (
          <WebRoute>
            <MinutaUserRoute>
              <MinutaUser />
            </MinutaUserRoute>
          </WebRoute>
        ),
        errorElement: <ErrorPage />
      },
      {
        path: '/edit-preview/:editId',
        element: (
          <WebRoute>
            <EditPreview />
          </WebRoute>
        ),
        errorElement: <ErrorPage />
      },
      {
        path: ROUTES.DASHBOARD_HOME.path,
        element: (
          <WebRoute>
            <AuthenticatedLayout>
              <AlertsPage />
            </AuthenticatedLayout>
          </WebRoute>
        ),
        errorElement: <ErrorPage />
      },
      {
        path: ROUTES.ALERTS.path,
        element: (
          <WebRoute>
            <AuthenticatedLayout>
              <AlertsPage />
            </AuthenticatedLayout>
          </WebRoute>
        ),
        errorElement: <ErrorPage />
      },
      {
        path: ROUTES.CLIENTS.path,
        element: (
          <WebRoute>
            <AuthenticatedLayout>
              <ClientesListPage />
            </AuthenticatedLayout>
          </WebRoute>
        ),
        errorElement: <ErrorPage />
      },
      {
        path: ROUTES.GENERATE_MINUTE.path,
        element: (
          <WebRoute>
            <AuthenticatedLayout>
              <GerarMinutaPage />
            </AuthenticatedLayout>
          </WebRoute>
        ),
        errorElement: <ErrorPage />
      },
      {
        path: ROUTES.REGISTER_CLIENT.path,
        element: (
          <WebRoute>
            <AuthenticatedLayout>
              <CadastrarClientePage />
            </AuthenticatedLayout>
          </WebRoute>
        ),
        errorElement: <ErrorPage />
      },
      {
        path: ROUTES.REGISTER_CLIENT_CNPJ.path,
        element: (
          <WebRoute>
            <AuthenticatedLayout>
              <CadastrarClientePageCnpj />
            </AuthenticatedLayout>
          </WebRoute>
        ),
        errorElement: <ErrorPage />
      },
      // {
      //   path: ROUTES.REGISTER_CLIENT_CPF.path,
      //   element: (
      //     <WebRoute>
      //       <AuthenticatedLayout>
      //         <CadastrarClientePageCpf />
      //       </AuthenticatedLayout>
      //     </WebRoute>
      //   ),
      //   errorElement: <ErrorPage />
      // },
      {
        path: ROUTES.REGISTER_CLIENT_PF.path,
        element: (
          <WebRoute>
            <AuthenticatedLayout>
              <CadastrarClientePagePf />
            </AuthenticatedLayout>
          </WebRoute>
        ),
        errorElement: <ErrorPage />
      },
      {
        path: ROUTES.PARTNERS.path,
        element: (
          <WebRoute>
            <AuthenticatedLayout>
              <ListarParceirosPage />
            </AuthenticatedLayout>
          </WebRoute>
        ),
        errorElement: <ErrorPage />
      },
      {
        path: ROUTES.REGISTER_PARTNER.path,
        element: (
          <WebRoute>
            <AuthenticatedLayout>
              <CadastrarParceiroPage />
            </AuthenticatedLayout>
          </WebRoute>
        ),
        errorElement: <ErrorPage />
      },
      {
        path: ROUTES.REGISTER_ACCOUNTING.path,
        element: (
          <WebRoute>
            <AuthenticatedLayout>
              <CadastrarContabilidadePage />
            </AuthenticatedLayout>
          </WebRoute>
        ),
        errorElement: <ErrorPage />
      },
      {
        path: 'admin',
        children: [
          {
            path: 'home',
            element: <Navigate to={ROUTES.ALERTS.path} replace />
          },
          {
            path: ':cnpjcpf/clientes',
            element: (
              <WebRoute>
                <AuthenticatedLayout>
                  <ClientesListPage />
                </AuthenticatedLayout>
              </WebRoute>
            ),
            errorElement: <ErrorPage />
          },

          {
            path: ':tenant/clientes/:cnpjcpf',
            element: (
              <WebRoute>
                <AuthenticatedLayout>
                  <PermissionRoute permissionType="clients">
                    <ClientesPage />
                  </PermissionRoute>
                </AuthenticatedLayout>
              </WebRoute>
            ),
            errorElement: <ErrorPage />
          },
          {
            path: ':tenant/clientes/:cnpjcpf/informacoes',
            element: (
              <WebRoute>
                <AuthenticatedLayout>
                  <PermissionRoute permissionType="clients">
                    <ClientsInfo />
                  </PermissionRoute>
                </AuthenticatedLayout>
              </WebRoute>
            ),
            errorElement: <ErrorPage />
          },
          {
            path: ':tenant/clientes/:cnpjcpf/adicionar-produto',
            element: (
              <WebRoute>
                <AuthenticatedLayout>
                  <PermissionRoute permissionType="clients">
                    <ClientsAddProduct />
                  </PermissionRoute>
                </AuthenticatedLayout>
              </WebRoute>
            ),
            errorElement: <ErrorPage />
          },
          {
            path: ':tenant/clientes/:cnpjcpf/lista-minutas',
            element: (
              <WebRoute>
                <AuthenticatedLayout>
                  <ListarAgreements />
                </AuthenticatedLayout>
              </WebRoute>
            ),
            errorElement: <ErrorPage />
          },
          {
            path: ':tenant/clientes/:cnpjcpf/produtos',
            element: (
              <WebRoute>
                <AuthenticatedLayout>
                  <PermissionRoute permissionType="clients">
                    <ClientsProducts />
                  </PermissionRoute>
                </AuthenticatedLayout>
              </WebRoute>
            ),
            errorElement: <ErrorPage />
          },
          {
            path: ':cnpjcpf/opcoes-financeiras',
            element: (
              <WebRoute>
                <AuthenticatedLayout>
                  <FinanceiraResumo />
                </AuthenticatedLayout>
              </WebRoute>
            ),
            errorElement: <ErrorPage />
          },
          {
            path: ':cnpjcpf/opcoes-fiscais',
            element: (
              <WebRoute>
                <AuthenticatedLayout>
                  <ResumoBoleto />
                </AuthenticatedLayout>
              </WebRoute>
            ),
            errorElement: <ErrorPage />
          },
          {
            path: 'usuarios',
            element: (
              <WebRoute>
                <AdminRoute>
                  <UsersPage />
                </AdminRoute>
              </WebRoute>
            ),
            errorElement: <ErrorPage />
          },

          {
            path: 'usuarios/:id',
            element: (
              <WebRoute>
                <AdminRoute>
                  <UserDetailsPage />
                </AdminRoute>
              </WebRoute>
            ),
            errorElement: <ErrorPage />,
            children: [
              { index: true, element: <Navigate to="./permissoes" replace /> },
              { path: 'permissoes', element: <PermissionsManagerWrapper /> },
              { path: 'editar', element: <UserEditWrapper /> }
              // { path: 'clientes', element: <ClientPermissionsWrapper /> }
            ]
          },

          {
            path: 'product-analista',
            element: (
              <WebRoute>
                <AdminRoute>
                  <ProductManagement />
                </AdminRoute>
              </WebRoute>
            ),
            errorElement: <ErrorPage />
          },
          {
            path: 'contratos',
            element: (
              <WebRoute>
                <AdminRoute>
                  <ContratoForm />
                </AdminRoute>
              </WebRoute>
            ),
            errorElement: <ErrorPage />
          },

          {
            path: 'info-banco',
            element: (
              <WebRoute>
                <AdminRoute>
                  <BankRegistration />
                </AdminRoute>
              </WebRoute>
            ),
            errorElement: <ErrorPage />
          }
        ]
      },
      {
        path: ROUTES.AGREEMENT_SIGNATURES.path,
        element: (
          <WebRoute>
            <AuthenticatedLayout>
              <SignaturesPage />
            </AuthenticatedLayout>
          </WebRoute>
        ),
        errorElement: <ErrorPage />
      },
      {
        path: 'cliente/:cnpjcpf',
        element: (
          <WebRoute>
            <Protected>
              <PermissionRoute permissionType="clients">
                <AuthenticatedLayout>
                  <ClientesPage />
                </AuthenticatedLayout>
              </PermissionRoute>
            </Protected>
          </WebRoute>
        ),
        errorElement: <ErrorPage />
      },
      {
        path: 'cliente/:cnpjcpf/informacoes',
        element: (
          <WebRoute>
            <AuthenticatedLayout>
              <PermissionRoute permissionType="clients">
                <ClientsInfo />
              </PermissionRoute>
            </AuthenticatedLayout>
          </WebRoute>
        ),
        errorElement: <ErrorPage />
      },
      {
        path: 'cliente/:cnpjcpf/adicionar-produto',
        element: (
          <WebRoute>
            <AuthenticatedLayout>
              <PermissionRoute permissionType="clients">
                <ClientsAddProduct />
              </PermissionRoute>
            </AuthenticatedLayout>
          </WebRoute>
        ),
        errorElement: <ErrorPage />
      },
      {
        path: 'cliente/:cnpjcpf/lista-minutas',
        element: (
          <WebRoute>
            <AuthenticatedLayout>
              <ListarAgreements />
            </AuthenticatedLayout>
          </WebRoute>
        ),
        errorElement: <ErrorPage />
      },
      {
        path: 'cliente/:cnpjcpf/produtos',
        element: (
          <WebRoute>
            <AuthenticatedLayout>
              <PermissionRoute permissionType="clients">
                <ClientsProducts />
              </PermissionRoute>
            </AuthenticatedLayout>
          </WebRoute>
        ),
        errorElement: <ErrorPage />
      }
    ]
  },

  {
    path: ROUTES.NOT_FOUND.path,
    element: (
      <WebRoute>
        {/* <SigninProtected> */}
        <SignIn />
        {/* </SigninProtected> */}
      </WebRoute>
    ),
    errorElement: <ErrorPage />
  }
])

export default RouterList
